// extracted by mini-css-extract-plugin
module.exports = {"container":"_334FhLFVd7QGw8BDyjo4S6","groupsList":"_2TBBn9roawDWO9-pT_QgHO"};